<template>
  <div class="machine-tuning-page" dir="rtl">
    <v-container fluid>
      <v-card class="pa-4 elevation-2">
        <v-card-title class="justify-space-between align-center flex-wrap">
          <div class="page-title">تنظیم ماشین</div>
          <div class="d-flex flex-wrap align-center">
            <v-btn
              color="primary"
              class="ml-2 mb-2"
              dark
              @click="openGroupUploadDialog"
            >
              آپلود فایل گروهی
            </v-btn>
            <v-btn
              color="secondary"
              class="ml-2 mb-2"
              dark
              @click="openCreateRecordDialog"
            >
              ساخت رکورد
            </v-btn>
            <v-btn
              color="warning"
              class="ml-2 mb-2"
              :disabled="!selected.length"
              dark
              @click="openBulkEdit"
            >
              ویرایش گروهی
            </v-btn>
            <v-btn
              color="error"
              class="mb-2"
              :disabled="!selected.length"
              dark
              @click="openBulkDelete"
            >
              حذف گروهی
            </v-btn>
          </div>
        </v-card-title>

        <v-card class="mb-6 filter-card" outlined>
          <v-card-title class="justify-space-between align-center">
            <span>فیلترها</span>
            <v-btn icon @click="toggleFilterPanel">
              <v-icon>{{ filterPanel ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-btn>
          </v-card-title>
          <v-expand-transition>
            <div v-show="filterPanel">
              <v-divider></v-divider>
              <v-card-text>
                <v-form ref="filterForm">
                  <v-row dense>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field
                        v-model="filters.search"
                        label="جستجو"
                        color="black"
                        clearable
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field
                        v-model="filters.file_name"
                        label="نام فایل"
                        color="black"
                        clearable
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field
                        v-model="filters.original_name"
                        label="نام اصلی"
                        color="black"
                        clearable
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field
                        v-model="filters.format"
                        label="فرمت"
                        color="black"
                        clearable
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field
                        v-model="filters.item_id"
                        label="شناسه آیتم"
                        color="black"
                        clearable
                        type="number"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field
                        v-model="filters.duration_min"
                        label="حداقل مدت (ثانیه)"
                        color="black"
                        clearable
                        type="number"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field
                        v-model="filters.duration_max"
                        label="حداکثر مدت (ثانیه)"
                        color="black"
                        clearable
                        type="number"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field
                        v-model="filters.size_min"
                        label="حداقل حجم (بایت)"
                        color="black"
                        clearable
                        type="number"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field
                        v-model="filters.size_max"
                        label="حداکثر حجم (بایت)"
                        color="black"
                        clearable
                        type="number"
                      ></v-text-field>
                    </v-col>
                    <template v-for="score in scoreFields">
                      <v-col :key="'equals-' + score.key" cols="12" sm="6" md="3">
                        <v-text-field
                          v-model="filters[score.key]"
                          :label="score.label"
                          color="black"
                          clearable
                          type="number"
                        ></v-text-field>
                      </v-col>
                    </template>
                    <template v-for="score in scoreFields">
                      <v-col :key="'min-' + score.key" cols="12" sm="6" md="3">
                        <v-text-field
                          v-model="filters[score.key + '_min']"
                          :label="'حداقل ' + score.shortLabel"
                          color="black"
                          clearable
                          type="number"
                        ></v-text-field>
                      </v-col>
                      <v-col :key="'max-' + score.key" cols="12" sm="6" md="3">
                        <v-text-field
                          v-model="filters[score.key + '_max']"
                          :label="'حداکثر ' + score.shortLabel"
                          color="black"
                          clearable
                          type="number"
                        ></v-text-field>
                      </v-col>
                    </template>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field
                        v-model="filters.created_from"
                        label="تاریخ ایجاد از"
                        color="black"
                        type="date"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field
                        v-model="filters.created_to"
                        label="تاریخ ایجاد تا"
                        color="black"
                        type="date"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field
                        v-model="filters.updated_from"
                        label="آخرین بروزرسانی از"
                        color="black"
                        type="date"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field
                        v-model="filters.updated_to"
                        label="آخرین بروزرسانی تا"
                        color="black"
                        type="date"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-switch
                        v-model="filters.scored"
                        label="فقط فایل‌های دارای همه امتیازها"
                        inset
                        color="success"
                      ></v-switch>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-switch
                        v-model="filters.missing_scores"
                        label="فقط فایل‌های ناقص"
                        inset
                        color="warning"
                      ></v-switch>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-select
                        v-model="filters.sort_by"
                        :items="sortOptions"
                        label="مرتب‌سازی بر اساس"
                        color="black"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-select
                        v-model="filters.sort_direction"
                        :items="sortDirections"
                        label="جهت مرتب‌سازی"
                        color="black"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-select
                        v-model="filters.per_page"
                        :items="perPageOptions"
                        label="تعداد در هر صفحه"
                        color="black"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" class="d-flex justify-end">
                      <v-btn color="primary" class="ml-2" dark @click="applyFilters">
                        جستجو
                      </v-btn>
                      <v-btn color="secondary" dark @click="resetFilters">
                        پاک‌سازی فیلترها
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
            </div>
          </v-expand-transition>
        </v-card>

        <v-card-text class="pb-0">
          <div class="d-flex justify-space-between align-center flex-wrap mb-4">
            <div>تعداد انتخاب‌شده: {{ selected.length }}</div>
            <div>کل نتایج: {{ pagination.total }}</div>
          </div>
          <v-data-table
            class="elevation-1"
            :headers="headers"
            :items="items"
            :options.sync="tableOptions"
            :server-items-length="pagination.total"
            :loading="tableLoading"
            :items-per-page="tableOptions.itemsPerPage"
            item-key="id"
            show-select
            :footer-props="dataTableFooterProps"
            :no-data-text="'اطلاعاتی یافت نشد'"
            :loading-text="'در حال بارگذاری...'"
            :mobile-breakpoint="0"
            dense
            v-model="selected"
          >
            <template v-slot:[`item.file_name`]="{ item }">
              <div :id="'audio-row-' + item.id">{{ item.file_name }}</div>
            </template>
            <template v-slot:[`item.duration`]="{ item }">
              {{ formatDuration(item.duration) }}
            </template>
            <template v-slot:[`item.size_display`]="{ item }">
              {{ formatSize(item) }}
            </template>
            <template v-slot:[`item.item_id`]="{ item }">
              <v-text-field
                v-model="item.edited.item_id"
                type="number"
                hide-details="auto"
                dense
                class="score-input"
                color="black"
                clearable
                @input="onRowFieldChange(item, 'item_id')"
                :error-messages="getRowError(item.id, 'item_id')"
              ></v-text-field>
            </template>
            <template v-slot:[`item.timber`]="{ item }">
              <v-text-field
                v-model="item.edited.timber"
                type="number"
                min="0"
                max="100"
                step="0.01"
                hide-details="auto"
                dense
                class="score-input"
                color="black"
                clearable
                @input="onRowFieldChange(item, 'timber')"
                :error-messages="getRowError(item.id, 'timber')"
              ></v-text-field>
            </template>
            <template v-slot:[`item.timeout`]="{ item }">
              <v-text-field
                v-model="item.edited.timeout"
                type="number"
                min="0"
                max="100"
                step="0.01"
                hide-details="auto"
                dense
                class="score-input"
                color="black"
                clearable
                @input="onRowFieldChange(item, 'timeout')"
                :error-messages="getRowError(item.id, 'timeout')"
              ></v-text-field>
            </template>
            <template v-slot:[`item.brightness`]="{ item }">
              <v-text-field
                v-model="item.edited.brightness"
                type="number"
                min="0"
                max="100"
                step="0.01"
                hide-details="auto"
                dense
                class="score-input"
                color="black"
                clearable
                @input="onRowFieldChange(item, 'brightness')"
                :error-messages="getRowError(item.id, 'brightness')"
              ></v-text-field>
            </template>
            <template v-slot:[`item.loudness`]="{ item }">
              <v-text-field
                v-model="item.edited.loudness"
                type="number"
                min="0"
                max="100"
                step="0.01"
                hide-details="auto"
                dense
                class="score-input"
                color="black"
                clearable
                @input="onRowFieldChange(item, 'loudness')"
                :error-messages="getRowError(item.id, 'loudness')"
              ></v-text-field>
            </template>
            <template v-slot:[`item.compliance`]="{ item }">
              <v-text-field
                v-model="item.edited.compliance"
                type="number"
                min="0"
                max="100"
                step="0.01"
                hide-details="auto"
                dense
                class="score-input"
                color="black"
                clearable
                @input="onRowFieldChange(item, 'compliance')"
                :error-messages="getRowError(item.id, 'compliance')"
              ></v-text-field>
            </template>
            <template v-slot:[`item.playback`]="{ item }">
              <audio
                v-if="item.playback_url"
                :src="item.playback_url"
                controls
                preload="none"
                class="audio-player"
              ></audio>
              <span v-else>ناموجود</span>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                color="success"
                small
                dark
                :loading="rowLoading[item.id]"
                :disabled="!item.hasChanges || rowHasErrors(item)"
                @click="saveRow(item)"
              >
                ثبت ویرایش
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>

    <v-dialog
      v-model="bulkEditDialog"
      max-width="720"
      scrollable
      @keydown.esc="bulkEditDialog = false"
    >
      <v-card>
        <v-card-title class="justify-space-between align-center">
          <span>ویرایش گروهی</span>
          <v-btn icon @click="bulkEditDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <p class="mb-4">
            این تغییرات بر روی {{ selected.length }} فایل انتخاب‌شده اعمال خواهد شد.
          </p>
          <v-form ref="bulkEditForm">
            <v-row dense>
              <v-col cols="12" sm="6">
                <v-checkbox
                  v-model="bulkEditForm.apply.item_id"
                  label="اعمال شناسه آیتم"
                  color="primary"
                ></v-checkbox>
                <v-text-field
                  v-model="bulkEditForm.values.item_id"
                  label="شناسه آیتم"
                  type="number"
                  color="black"
                  :disabled="!bulkEditForm.apply.item_id"
                  :error-messages="bulkEditErrors.item_id"
                  clearable
                  hide-details="auto"
                  @input="clearBulkEditError('item_id')"
                ></v-text-field>
                <small class="helper-text">برای خالی کردن شناسه، مقدار را خالی بگذارید.</small>
              </v-col>
              <template v-for="score in scoreFields">
                <v-col :key="'bulk-' + score.key" cols="12" sm="6">
                  <v-checkbox
                    v-model="bulkEditForm.apply[score.key]"
                    :label="'اعمال ' + score.shortLabel"
                    color="primary"
                  ></v-checkbox>
                  <v-text-field
                    v-model="bulkEditForm.values[score.key]"
                    :label="score.label"
                    type="number"
                    min="0"
                    max="100"
                    step="0.01"
                    color="black"
                    :disabled="!bulkEditForm.apply[score.key]"
                    :error-messages="bulkEditErrors[score.key]"
                    clearable
                    hide-details="auto"
                    @input="clearBulkEditError(score.key)"
                  ></v-text-field>
                </v-col>
              </template>
              <v-col cols="12">
                <v-checkbox
                  v-model="bulkEditForm.apply.metadata"
                  label="اعمال متادیتا"
                  color="primary"
                ></v-checkbox>
                <v-textarea
                  v-model="bulkEditForm.values.metadata"
                  label="متادیتا (JSON)"
                  auto-grow
                  rows="3"
                  color="black"
                  :disabled="!bulkEditForm.apply.metadata"
                  :error-messages="bulkEditErrors.metadata"
                  @input="clearBulkEditError('metadata')"
                ></v-textarea>
                <small class="helper-text">در صورت خالی بودن این بخش، متادیتایی ارسال نخواهد شد.</small>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-space-between">
          <v-btn text color="grey" @click="bulkEditDialog = false">انصراف</v-btn>
          <v-btn
            color="success"
            dark
            :loading="bulkEditLoading"
            :disabled="!selected.length"
            @click="submitBulkEdit"
          >
            ذخیره تغییرات
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="bulkDeleteDialog"
      max-width="520"
      @keydown.esc="bulkDeleteDialog = false"
    >
      <v-card>
        <v-card-title class="justify-space-between align-center">
          <span>حذف گروهی</span>
          <v-btn icon @click="bulkDeleteDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          آیا از حذف {{ selected.length }} فایل انتخاب‌شده اطمینان دارید؟ این عملیات قابل بازگشت نیست.
        </v-card-text>
        <v-card-actions class="justify-space-between">
          <v-btn text color="grey" @click="bulkDeleteDialog = false">انصراف</v-btn>
          <v-btn
            color="error"
            dark
            :loading="bulkDeleteLoading"
            :disabled="!selected.length"
            @click="confirmBulkDelete"
          >
            حذف
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="groupUploadDialog"
      max-width="720"
      scrollable
      @keydown.esc="groupUploadDialog = false"
    >
      <v-card>
        <v-card-title class="justify-space-between align-center">
          <span>آپلود فایل گروهی</span>
          <v-btn icon @click="groupUploadDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <p class="mb-4">
            ابتدا فایل‌های صوتی مورد نظر را بارگذاری کنید و سپس جزئیات دیگر را از طریق جدول ویرایش نمایید.
          </p>
          <div class="d-flex align-center mb-4">
            <v-btn color="primary" dark small class="ml-2" @click="addGroupFileField">
              <v-icon small class="mr-1">mdi-plus</v-icon>
              افزودن فایل
            </v-btn>
            <span class="grey--text text--darken-1">می‌توانید هر تعداد فایل صوتی اضافه کنید.</span>
          </div>
          <v-form ref="groupUploadFormRef">
            <v-row dense>
              <v-col
                v-for="(fileField, index) in groupUploadForm.files"
                :key="fileField.uid"
                cols="12"
              >
                <div class="d-flex align-center group-file-field">
                  <div class="flex-grow-1">
                    <label :for="`group-file-${fileField.uid}`" class="file-input-label">
                      فایل صوتی {{ index + 1 }}
                    </label>
                    <input
                      :id="`group-file-${fileField.uid}`"
                      ref="groupFileInputs"
                      type="file"
                      accept="audio/*"
                      class="file-input"
                      @change="onGroupFileChange($event, index)"
                    >
                    <div v-if="fileField.file" class="mt-2">{{ fileField.file.name }}</div>
                  </div>
                  <v-btn
                    v-if="groupUploadForm.files.length > 1"
                    icon
                    color="error"
                    class="ml-2"
                    @click="removeGroupFileField(index)"
                  >
                    <v-icon>mdi-minus</v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            <div v-if="groupUploadErrors.files" class="error-text mt-2">
              {{ groupUploadErrors.files.join('، ') }}
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text color="grey" @click="groupUploadDialog = false">انصراف</v-btn>
          <v-btn
            color="success"
            dark
            :loading="groupUploadLoading"
            @click="submitGroupUpload"
          >
            ارسال فایل‌ها
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="createRecordDialog"
      max-width="880"
      scrollable
      @keydown.esc="createRecordDialog = false"
    >
      <v-card>
        <v-card-title class="justify-space-between align-center">
          <span>ساخت رکورد جدید</span>
          <v-btn icon @click="createRecordDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="createRecordFormRef">
            <v-row dense class="mt-2">
              <v-col cols="12">
                <label class="file-input-label" for="create-record-file">انتخاب فایل صوتی</label>
                <input
                  id="create-record-file"
                  ref="createRecordFileInput"
                  type="file"
                  accept="audio/*"
                  class="file-input"
                  @change="onCreateRecordFileChange"
                >
                <div v-if="createRecordErrors.file" class="error-text">
                  {{ createRecordErrors.file.join('، ') }}
                </div>
                <div v-if="createRecordForm.file" class="mt-2">{{ createRecordForm.file.name }}</div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="createRecordForm.item_id"
                  label="شناسه آیتم"
                  type="number"
                  color="black"
                  clearable
                  :error-messages="createRecordErrors.item_id"
                  hide-details="auto"
                  @input="clearCreateRecordError('item_id')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="createRecordForm.file_name"
                  label="نام فایل"
                  color="black"
                  clearable
                  :error-messages="createRecordErrors.file_name"
                  hide-details="auto"
                  @input="clearCreateRecordError('file_name')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="createRecordForm.original_name"
                  label="نام اصلی"
                  color="black"
                  clearable
                  :error-messages="createRecordErrors.original_name"
                  hide-details="auto"
                  @input="clearCreateRecordError('original_name')"
                ></v-text-field>
              </v-col>
              <template v-for="score in scoreFields">
                <v-col :key="'create-' + score.key" cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="createRecordForm[score.key]"
                    :label="score.label"
                    type="number"
                    min="0"
                    max="100"
                    step="0.01"
                    color="black"
                    clearable
                    :error-messages="createRecordErrors[score.key]"
                    hide-details="auto"
                    @input="clearCreateRecordError(score.key)"
                  ></v-text-field>
                </v-col>
              </template>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text color="grey" @click="createRecordDialog = false">انصراف</v-btn>
          <v-btn
            color="success"
            dark
            :loading="createRecordLoading"
            @click="submitCreateRecord"
          >
            ثبت رکورد
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const createGroupFileField = () => ({
  uid: `group-file-${Math.random().toString(36).substr(2, 9)}-${Date.now()}`,
  file: null
});

export default {
  name: 'MachineTuningIndex',
  data() {
    return {
      headers: [
        { text: 'نام فایل', value: 'file_name', align: 'center', sortable: true },
        { text: 'نام اصلی', value: 'original_name', align: 'center', sortable: true },
        { text: 'مدت', value: 'duration', align: 'center', sortable: true },
        { text: 'فرمت', value: 'format', align: 'center', sortable: true },
        { text: 'حجم', value: 'size_display', align: 'center', sortable: true },
        { text: 'شناسه آیتم', value: 'item_id', align: 'center', sortable: true },
        { text: 'Timber', value: 'timber', align: 'center', sortable: true },
        { text: 'Timeout', value: 'timeout', align: 'center', sortable: true },
        { text: 'Brightness', value: 'brightness', align: 'center', sortable: true },
        { text: 'Loudness', value: 'loudness', align: 'center', sortable: true },
        { text: 'Compliance', value: 'compliance', align: 'center', sortable: true },
        { text: 'پخش', value: 'playback', align: 'center', sortable: false },
        { text: 'عملیات', value: 'actions', align: 'center', sortable: false }
      ],
      items: [],
      selected: [],
      tableOptions: {
        page: 1,
        itemsPerPage: 15,
        sortBy: ['created_at'],
        sortDesc: [true]
      },
      pagination: {
        total: 0,
        per_page: 15,
        current_page: 1,
        last_page: 1
      },
      tableLoading: false,
      filters: {
        search: '',
        file_name: '',
        original_name: '',
        format: '',
        item_id: '',
        duration_min: '',
        duration_max: '',
        size_min: '',
        size_max: '',
        timber: '',
        timber_min: '',
        timber_max: '',
        timeout: '',
        timeout_min: '',
        timeout_max: '',
        brightness: '',
        brightness_min: '',
        brightness_max: '',
        loudness: '',
        loudness_min: '',
        loudness_max: '',
        compliance: '',
        compliance_min: '',
        compliance_max: '',
        created_from: '',
        created_to: '',
        updated_from: '',
        updated_to: '',
        scored: false,
        missing_scores: false,
        sort_by: 'created_at',
        sort_direction: 'desc',
        per_page: 15
      },
      defaultFilters: {},
      filterPanel: false,
      internalOptionsUpdate: false,
      rowErrors: {},
      rowLoading: {},
      lastCreatedId: null,
      bulkEditDialog: false,
      bulkEditForm: {
        apply: {
          item_id: false,
          timber: false,
          timeout: false,
          brightness: false,
          loudness: false,
          compliance: false,
          metadata: false
        },
        values: {
          item_id: '',
          timber: '',
          timeout: '',
          brightness: '',
          loudness: '',
          compliance: '',
          metadata: ''
        }
      },
      bulkEditErrors: {},
      bulkEditLoading: false,
      bulkDeleteDialog: false,
      bulkDeleteLoading: false,
      groupUploadDialog: false,
      groupUploadForm: {
        files: [createGroupFileField()]
      },
      groupUploadErrors: {},
      groupUploadLoading: false,
      createRecordDialog: false,
      createRecordForm: {
        file: null,
        item_id: '',
        file_name: '',
        original_name: '',
        timber: '',
        timeout: '',
        brightness: '',
        loudness: '',
        compliance: ''
      },
      createRecordErrors: {},
      createRecordLoading: false,
      scoreFields: [
        { key: 'timber', label: 'امتیاز Timber', shortLabel: 'Timber' },
        { key: 'timeout', label: 'Timeout', shortLabel: 'Timeout' },
        { key: 'brightness', label: 'Brightness', shortLabel: 'Brightness' },
        { key: 'loudness', label: 'Loudness', shortLabel: 'Loudness' },
        { key: 'compliance', label: 'Compliance', shortLabel: 'Compliance' }
      ],
      sortOptions: [
        { text: 'تاریخ ایجاد', value: 'created_at' },
        { text: 'نام فایل', value: 'file_name' },
        { text: 'نام اصلی', value: 'original_name' },
        { text: 'مدت', value: 'duration' },
        { text: 'فرمت', value: 'format' },
        { text: 'حجم', value: 'size' },
        { text: 'شناسه آیتم', value: 'item_id' },
        { text: 'Timber', value: 'timber' },
        { text: 'Timeout', value: 'timeout' },
        { text: 'Brightness', value: 'brightness' },
        { text: 'Loudness', value: 'loudness' },
        { text: 'Compliance', value: 'compliance' }
      ],
      sortDirections: [
        { text: 'صعودی', value: 'asc' },
        { text: 'نزولی', value: 'desc' }
      ],
      perPageOptions: [10, 15, 25, 50, 100]
    };
  },
  computed: {
    scoreFieldKeys() {
      return this.scoreFields.map(field => field.key);
    },
    dataTableFooterProps() {
      return {
        'items-per-page-options': this.perPageOptions,
        'items-per-page-text': 'تعداد در هر صفحه',
        'items-per-page-all-text': 'همه',
        'page-text': this.footerPageText
      };
    }
  },
  created() {
    this.defaultFilters = JSON.parse(JSON.stringify(this.filters));
    this.internalOptionsUpdate = true;
    this.tableOptions.sortBy = [this.filters.sort_by];
    this.tableOptions.sortDesc = [this.filters.sort_direction === 'desc'];
    this.tableOptions.itemsPerPage = this.filters.per_page;
    this.internalOptionsUpdate = false;
    this.fetchItems();
  },
  watch: {
    tableOptions: {
      deep: true,
      handler() {
        if (this.internalOptionsUpdate) {
          this.internalOptionsUpdate = false;
          return;
        }
        this.syncFiltersWithOptions();
        this.fetchItems();
      }
    },
    bulkEditDialog(value) {
      if (!value) {
        this.resetBulkEditForm();
      }
    },
    groupUploadDialog(value) {
      if (!value) {
        this.resetGroupUploadForm();
      }
    },
    createRecordDialog(value) {
      if (!value) {
        this.resetCreateRecordForm();
      }
    }
  },
  methods: {
    footerPageText(pageStart, pageStop) {
      if (!this.pagination.total) {
        return 'بدون داده';
      }
      return `${pageStart} تا ${pageStop} از ${this.pagination.total} مورد`;
    },
    syncFiltersWithOptions() {
      const sortBy = this.tableOptions.sortBy && this.tableOptions.sortBy.length ? this.tableOptions.sortBy[0] : 'created_at';
      const sortDesc = this.tableOptions.sortDesc && this.tableOptions.sortDesc.length ? this.tableOptions.sortDesc[0] : true;
      this.filters.sort_by = sortBy;
      this.filters.sort_direction = sortDesc ? 'desc' : 'asc';
      this.filters.per_page = this.tableOptions.itemsPerPage;
    },
    toggleFilterPanel() {
      this.filterPanel = !this.filterPanel;
    },
    applyFilters() {
      this.internalOptionsUpdate = true;
      this.tableOptions.page = 1;
      this.tableOptions.itemsPerPage = this.filters.per_page;
      this.tableOptions.sortBy = [this.filters.sort_by];
      this.tableOptions.sortDesc = [this.filters.sort_direction === 'desc'];
      this.internalOptionsUpdate = false;
      this.fetchItems();
    },
    resetFilters() {
      this.filters = JSON.parse(JSON.stringify(this.defaultFilters));
      this.applyFilters();
    },
    buildQueryParams() {
      const params = {};
      params.page = this.tableOptions.page;
      params.per_page = this.tableOptions.itemsPerPage;
      if (this.filters.sort_by) {
        params.sort_by = this.filters.sort_by;
      }
      if (this.filters.sort_direction) {
        params.sort_direction = this.filters.sort_direction;
      }
      const numericFields = [
        'item_id',
        'duration_min', 'duration_max',
        'size_min', 'size_max',
        'timber', 'timber_min', 'timber_max',
        'timeout', 'timeout_min', 'timeout_max',
        'brightness', 'brightness_min', 'brightness_max',
        'loudness', 'loudness_min', 'loudness_max',
        'compliance', 'compliance_min', 'compliance_max'
      ];
      Object.keys(this.filters).forEach((key) => {
        if (['sort_by', 'sort_direction', 'per_page'].includes(key)) {
          return;
        }
        const value = this.filters[key];
        if (value === null || value === undefined || value === '') {
          return;
        }
        if (key === 'scored' || key === 'missing_scores') {
          if (value) {
            params[key] = 1;
          }
          return;
        }
        if (numericFields.includes(key)) {
          const numeric = Number(value);
          if (!isNaN(numeric)) {
            params[key] = numeric;
          }
          return;
        }
        params[key] = value;
      });
      return params;
    },
    fetchItems() {
      this.tableLoading = true;
      const params = this.buildQueryParams();
      window.axios.get('machine-learning/audio-files', { params })
        .then((response) => {
          const data = response.data?.data || {};
          const items = data.items || [];
          const pagination = data.pagination || {};
          this.items = items.map(item => this.mapFetchedItem(item));
          this.pagination = {
            total: pagination.total || 0,
            per_page: pagination.per_page || this.tableOptions.itemsPerPage,
            current_page: pagination.current_page || this.tableOptions.page,
            last_page: pagination.last_page || 1
          };
          if (this.pagination.current_page !== this.tableOptions.page) {
            this.internalOptionsUpdate = true;
            this.tableOptions.page = this.pagination.current_page;
            this.internalOptionsUpdate = false;
          }
          this.rowErrors = {};
          this.rowLoading = {};
          this.selected = [];
          this.$nextTick(() => {
            if (this.lastCreatedId) {
              const element = document.getElementById(`audio-row-${this.lastCreatedId}`);
              if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }
              this.lastCreatedId = null;
            }
          });
        })
        .catch((error) => {
          this.handleRequestError(error, 'خطا در دریافت فایل‌ها.');
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    mapFetchedItem(item) {
      const mapped = {
        ...item,
        metadata: item.metadata || {},
        edited: {
          item_id: item.item_id !== null && item.item_id !== undefined ? item.item_id : '',
        },
        original: {
          item_id: item.item_id !== undefined ? item.item_id : null,
        },
        hasChanges: false
      };
      this.scoreFieldKeys.forEach((field) => {
        mapped.edited[field] = item[field] !== null && item[field] !== undefined ? item[field] : '';
        mapped.original[field] = item[field] !== undefined ? item[field] : null;
      });
      return mapped;
    },
    formatDuration(value) {
      if (value === null || value === undefined || isNaN(Number(value))) {
        return '--';
      }
      const totalSeconds = Math.floor(Number(value));
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      return `${this.padNumber(minutes)}:${this.padNumber(seconds)}`;
    },
    padNumber(value) {
      return value.toString().padStart(2, '0');
    },
    formatSize(item) {
      if (item.metadata && item.metadata.size_readable) {
        return item.metadata.size_readable;
      }
      if (item.size === null || item.size === undefined) {
        return '--';
      }
      return this.humanReadableSize(item.size);
    },
    humanReadableSize(bytes) {
      const units = ['B', 'KB', 'MB', 'GB', 'TB'];
      let size = Number(bytes);
      let unitIndex = 0;
      while (size >= 1024 && unitIndex < units.length - 1) {
        size /= 1024;
        unitIndex += 1;
      }
      return `${size.toFixed(2)} ${units[unitIndex]}`;
    },
    onRowFieldChange(item, field) {
      this.clearRowError(item.id, field);
      if (field === 'item_id') {
        if (item.edited.item_id === '' || item.edited.item_id === null) {
          item.edited.item_id = '';
        } else {
          const numeric = Number(item.edited.item_id);
          if (isNaN(numeric)) {
            this.setRowError(item.id, field, 'مقدار معتبر نیست.');
          } else {
            item.edited.item_id = numeric;
          }
        }
      } else if (this.scoreFieldKeys.includes(field)) {
        if (item.edited[field] === '' || item.edited[field] === null) {
          item.edited[field] = '';
        } else {
          const numeric = Number(item.edited[field]);
          if (isNaN(numeric)) {
            this.setRowError(item.id, field, 'مقدار معتبر نیست.');
          } else {
            item.edited[field] = numeric;
            if (numeric < 0 || numeric > 100) {
              this.setRowError(item.id, field, 'مقدار باید بین ۰ تا ۱۰۰ باشد.');
            }
          }
        }
      }
      item.hasChanges = this.rowHasChanges(item);
    },
    rowHasErrors(item) {
      return !!(this.rowErrors[item.id] && Object.keys(this.rowErrors[item.id]).length);
    },
    rowHasChanges(item) {
      return Object.keys(this.getRowChanges(item)).length > 0;
    },
    getRowChanges(item) {
      const payload = {};
      const fields = ['item_id', ...this.scoreFieldKeys];
      fields.forEach((field) => {
        const edited = this.normalizeRowValue(field, item.edited[field]);
        const original = item.original[field];
        if (!this.areValuesEqual(original, edited)) {
          payload[field] = edited;
        }
      });
      return payload;
    },
    normalizeRowValue(field, value) {
      if (value === '' || value === null || value === undefined) {
        return null;
      }
      if (field === 'item_id') {
        return Number(value);
      }
      if (this.scoreFieldKeys.includes(field)) {
        return Number(value);
      }
      return value;
    },
    areValuesEqual(original, edited) {
      if (original === null || original === undefined) {
        return edited === null || edited === undefined;
      }
      if (edited === null || edited === undefined) {
        return original === null || original === undefined;
      }
      return Number(original) === Number(edited);
    },
    saveRow(item) {
      const changes = this.getRowChanges(item);
      if (!Object.keys(changes).length) {
        this.openSnackbar('هیچ تغییری برای ثبت وجود ندارد.', '#F1416C');
        return;
      }
      this.$set(this.rowLoading, item.id, true);
      window.axios.patch(`machine-learning/audio-files/${item.id}`, changes)
        .then((response) => {
          const data = response.data?.data || {};
          this.applyUpdatedRow(item, data);
          this.openSnackbar('ویرایش با موفقیت ثبت شد.', '#50CD89');
        })
        .catch((error) => {
          if (error.response && error.response.status === 422 && error.response.data?.errors) {
            this.setRowErrors(item.id, error.response.data.errors);
            this.openSnackbar('لطفاً خطاهای فیلدهای ردیف را بررسی کنید.', '#F1416C');
          } else {
            this.handleRequestError(error, 'خطا در ثبت ویرایش.');
          }
        })
        .finally(() => {
          this.$set(this.rowLoading, item.id, false);
        });
    },
    applyUpdatedRow(target, data) {
      Object.assign(target, data);
      target.metadata = data.metadata || {};
      target.original = {
        item_id: target.item_id !== undefined ? target.item_id : null
      };
      target.edited = {
        item_id: target.item_id !== null && target.item_id !== undefined ? target.item_id : ''
      };
      this.scoreFieldKeys.forEach((field) => {
        target.original[field] = target[field] !== undefined ? target[field] : null;
        target.edited[field] = target[field] !== null && target[field] !== undefined ? target[field] : '';
      });
      target.hasChanges = false;
      this.$delete(this.rowErrors, target.id);
    },
    setRowError(rowId, field, message) {
      if (!this.rowErrors[rowId]) {
        this.$set(this.rowErrors, rowId, {});
      }
      const messages = Array.isArray(message) ? message : [message];
      this.$set(this.rowErrors[rowId], field, messages);
    },
    clearRowError(rowId, field) {
      if (this.rowErrors[rowId] && this.rowErrors[rowId][field]) {
        this.$delete(this.rowErrors[rowId], field);
      }
    },
    setRowErrors(rowId, errors) {
      const rowError = {};
      Object.keys(errors).forEach((key) => {
        const field = key.split('.').pop();
        const value = errors[key];
        rowError[field] = Array.isArray(value) ? value : [value];
      });
      this.$set(this.rowErrors, rowId, rowError);
    },
    getRowError(rowId, field) {
      if (this.rowErrors[rowId] && this.rowErrors[rowId][field]) {
        return this.rowErrors[rowId][field];
      }
      return [];
    },
    openBulkEdit() {
      if (!this.selected.length) {
        return;
      }
      this.bulkEditDialog = true;
    },
    resetBulkEditForm() {
      this.bulkEditForm = {
        apply: {
          item_id: false,
          timber: false,
          timeout: false,
          brightness: false,
          loudness: false,
          compliance: false,
          metadata: false
        },
        values: {
          item_id: '',
          timber: '',
          timeout: '',
          brightness: '',
          loudness: '',
          compliance: '',
          metadata: ''
        }
      };
      this.bulkEditErrors = {};
    },
    clearBulkEditError(field) {
      if (this.bulkEditErrors[field]) {
        this.$delete(this.bulkEditErrors, field);
      }
    },
    submitBulkEdit() {
      if (!this.selected.length) {
        this.openSnackbar('هیچ فایلی انتخاب نشده است.', '#F1416C');
        return;
      }
      this.bulkEditErrors = {};
      const fieldsToApply = Object.keys(this.bulkEditForm.apply).filter(key => this.bulkEditForm.apply[key]);
      if (!fieldsToApply.length) {
        this.openSnackbar('هیچ فیلدی برای ویرایش انتخاب نشده است.', '#F1416C');
        return;
      }
      let hasValidationError = false;
      let parsedMetadata = null;
      if (fieldsToApply.includes('metadata') && this.bulkEditForm.values.metadata) {
        try {
          parsedMetadata = JSON.parse(this.bulkEditForm.values.metadata);
        } catch (e) {
          this.bulkEditErrors.metadata = ['ساختار متادیتا نامعتبر است.'];
          hasValidationError = true;
        }
      }
      fieldsToApply.forEach((field) => {
        if (this.scoreFieldKeys.includes(field)) {
          const value = this.bulkEditForm.values[field];
          if (value !== '' && value !== null && value !== undefined) {
            const numeric = Number(value);
            if (isNaN(numeric) || numeric < 0 || numeric > 100) {
              this.bulkEditErrors[field] = ['مقدار باید بین ۰ تا ۱۰۰ باشد.'];
              hasValidationError = true;
            }
          }
        }
        if (field === 'item_id') {
          const value = this.bulkEditForm.values.item_id;
          if (value !== '' && value !== null && value !== undefined && isNaN(Number(value))) {
            this.bulkEditErrors.item_id = ['مقدار معتبر نیست.'];
            hasValidationError = true;
          }
        }
      });
      if (hasValidationError) {
        this.openSnackbar('لطفاً خطاهای فرم را بررسی کنید.', '#F1416C');
        return;
      }
      const filesPayload = this.selected.map((item) => {
        const payload = { id: item.id };
        fieldsToApply.forEach((field) => {
          if (field === 'metadata') {
            if (parsedMetadata !== null) {
              payload.metadata = parsedMetadata;
            }
            return;
          }
          if (field === 'item_id') {
            if (this.bulkEditForm.values.item_id === '' || this.bulkEditForm.values.item_id === null) {
              payload.item_id = null;
            } else {
              payload.item_id = Number(this.bulkEditForm.values.item_id);
            }
            return;
          }
          const value = this.bulkEditForm.values[field];
          if (value === '' || value === null || value === undefined) {
            payload[field] = null;
          } else {
            payload[field] = Number(value);
          }
        });
        return payload;
      });
      if (this.bulkEditErrors.metadata && this.bulkEditErrors.metadata.length) {
        this.openSnackbar('لطفاً خطای متادیتا را برطرف کنید.', '#F1416C');
        return;
      }
      this.bulkEditLoading = true;
      window.axios.patch('machine-learning/audio-files/bulk', { files: filesPayload })
        .then((response) => {
          const data = response.data?.data || {};
          const updatedItems = data.items || [];
          updatedItems.forEach((updated) => {
            const existing = this.items.find(item => item.id === updated.id);
            if (existing) {
              this.applyUpdatedRow(existing, updated);
            }
          });
          this.openSnackbar('ویرایش گروهی با موفقیت انجام شد.', '#50CD89');
          this.bulkEditDialog = false;
          this.fetchItems();
        })
        .catch((error) => {
          if (error.response && error.response.status === 422 && error.response.data?.errors) {
            this.setBulkEditErrors(error.response.data.errors);
            this.openSnackbar('لطفاً خطاهای فرم را بررسی کنید.', '#F1416C');
          } else {
            this.handleRequestError(error, 'خطا در ویرایش گروهی.');
          }
        })
        .finally(() => {
          this.bulkEditLoading = false;
        });
    },
    setBulkEditErrors(errors) {
      const mapped = {};
      Object.keys(errors).forEach((key) => {
        const field = key.split('.').pop();
        if (!mapped[field]) {
          mapped[field] = [];
        }
        mapped[field] = mapped[field].concat(errors[key]);
      });
      this.bulkEditErrors = mapped;
    },
    openBulkDelete() {
      if (!this.selected.length) {
        return;
      }
      this.bulkDeleteDialog = true;
    },
    confirmBulkDelete() {
      if (!this.selected.length) {
        this.openSnackbar('هیچ فایلی انتخاب نشده است.', '#F1416C');
        return;
      }
      const ids = this.selected.map(item => item.id);
      this.bulkDeleteLoading = true;
      window.axios.delete('machine-learning/audio-files/bulk', { data: { ids } })
        .then(() => {
          this.openSnackbar('حذف فایل‌ها با موفقیت انجام شد.', '#50CD89');
          this.bulkDeleteDialog = false;
          this.fetchItems();
        })
        .catch((error) => {
          this.handleRequestError(error, 'خطا در حذف فایل‌ها.');
        })
        .finally(() => {
          this.bulkDeleteLoading = false;
        });
    },
    openGroupUploadDialog() {
      this.groupUploadDialog = true;
    },
    openCreateRecordDialog() {
      this.createRecordDialog = true;
    },
    resetGroupUploadForm() {
      const inputs = this.$refs.groupFileInputs;
      if (inputs) {
        const list = Array.isArray(inputs) ? inputs : [inputs];
        list.forEach((input) => {
          if (input) {
            input.value = null;
          }
        });
      }
      this.groupUploadForm = {
        files: [createGroupFileField()]
      };
      this.groupUploadErrors = {};
      this.groupUploadLoading = false;
    },
    addGroupFileField() {
      this.groupUploadForm.files.push(createGroupFileField());
      this.clearGroupUploadError('files');
    },
    removeGroupFileField(index) {
      if (this.groupUploadForm.files.length === 1) {
        const input = Array.isArray(this.$refs.groupFileInputs)
          ? this.$refs.groupFileInputs[0]
          : this.$refs.groupFileInputs;
        if (input) {
          input.value = null;
        }
        this.$set(this.groupUploadForm.files[0], 'file', null);
        return;
      }
      this.groupUploadForm.files.splice(index, 1);
      this.clearGroupUploadError('files');
    },
    onGroupFileChange(event, index) {
      const file = (event.target.files && event.target.files.length) ? event.target.files[0] : null;
      this.$set(this.groupUploadForm.files, index, {
        ...this.groupUploadForm.files[index],
        file
      });
      if (!file && event.target) {
        event.target.value = null;
      }
      if (file) {
        this.clearGroupUploadError('files');
      }
    },
    clearGroupUploadError(field) {
      if (this.groupUploadErrors[field]) {
        this.$delete(this.groupUploadErrors, field);
      }
    },
    submitGroupUpload() {
      this.groupUploadErrors = {};
      const files = this.groupUploadForm.files
        .map(fileField => fileField.file)
        .filter(file => !!file);
      if (!files.length) {
        this.groupUploadErrors.files = ['لطفاً دست‌کم یک فایل صوتی انتخاب کنید.'];
        this.openSnackbar('هیچ فایلی برای آپلود انتخاب نشده است.', '#F1416C');
        return;
      }
      const formData = new FormData();
      files.forEach((file) => {
        formData.append('files[]', file);
      });
      this.groupUploadLoading = true;
      window.axios.post('machine-learning/audio-files', formData)
        .then((response) => {
          const data = response.data?.data || {};
          const items = data.items || [];
          if (items.length) {
            this.lastCreatedId = items[0].id;
          }
          this.openSnackbar('فایل‌ها با موفقیت آپلود شدند.', '#50CD89');
          this.groupUploadDialog = false;
          this.internalOptionsUpdate = true;
          this.tableOptions.page = 1;
          this.internalOptionsUpdate = false;
          this.fetchItems();
        })
        .catch((error) => {
          if (error.response && error.response.status === 422 && error.response.data?.errors) {
            this.setGroupUploadErrors(error.response.data.errors);
          }
          this.handleRequestError(error, 'خطا در آپلود فایل‌ها.');
        })
        .finally(() => {
          this.groupUploadLoading = false;
        });
    },
    setGroupUploadErrors(errors) {
      const mapped = {};
      Object.keys(errors).forEach((key) => {
        const messages = Array.isArray(errors[key]) ? errors[key] : [errors[key]];
        if (key.split('.')[0] === 'files') {
          if (!mapped.files) {
            mapped.files = [];
          }
          mapped.files = mapped.files.concat(messages);
          return;
        }
        if (!mapped[key]) {
          mapped[key] = [];
        }
        mapped[key] = mapped[key].concat(messages);
      });
      this.groupUploadErrors = mapped;
    },
    resetCreateRecordForm() {
      if (this.$refs.createRecordFileInput) {
        this.$refs.createRecordFileInput.value = null;
      }
      this.createRecordForm = {
        file: null,
        item_id: '',
        file_name: '',
        original_name: '',
        timber: '',
        timeout: '',
        brightness: '',
        loudness: '',
        compliance: ''
      };
      this.createRecordErrors = {};
      this.createRecordLoading = false;
    },
    onCreateRecordFileChange(event) {
      const files = Array.from(event.target.files || []);
      this.createRecordForm.file = files.length ? files[0] : null;
      if (!this.createRecordForm.file && event.target) {
        event.target.value = null;
      }
      this.clearCreateRecordError('file');
    },
    clearCreateRecordError(field) {
      if (this.createRecordErrors[field]) {
        this.$delete(this.createRecordErrors, field);
      }
    },
    submitCreateRecord() {
      this.createRecordErrors = {};
      if (!this.createRecordForm.file) {
        this.createRecordErrors.file = ['لطفاً فایل صوتی مورد نظر را انتخاب کنید.'];
        this.openSnackbar('هیچ فایلی برای آپلود انتخاب نشده است.', '#F1416C');
        return;
      }
      const formData = new FormData();
      formData.append('files[]', this.createRecordForm.file);
      ['item_id', 'file_name', 'original_name'].forEach((field) => {
        const value = this.createRecordForm[field];
        if (value !== '' && value !== null && value !== undefined) {
          formData.append(field, value);
        }
      });
      this.scoreFieldKeys.forEach((field) => {
        const value = this.createRecordForm[field];
        if (value !== '' && value !== null && value !== undefined) {
          formData.append(field, value);
        }
      });
      this.createRecordLoading = true;
      window.axios.post('machine-learning/audio-files', formData)
        .then((response) => {
          const data = response.data?.data || {};
          const items = data.items || [];
          if (items.length) {
            this.lastCreatedId = items[0].id;
          }
          this.openSnackbar('رکورد جدید با موفقیت ایجاد شد.', '#50CD89');
          this.createRecordDialog = false;
          this.internalOptionsUpdate = true;
          this.tableOptions.page = 1;
          this.internalOptionsUpdate = false;
          this.fetchItems();
        })
        .catch((error) => {
          if (error.response && error.response.status === 422 && error.response.data?.errors) {
            this.setCreateRecordErrors(error.response.data.errors);
          }
          this.handleRequestError(error, 'خطا در ایجاد رکورد.');
        })
        .finally(() => {
          this.createRecordLoading = false;
        });
    },
    setCreateRecordErrors(errors) {
      const mapped = {};
      Object.keys(errors).forEach((key) => {
        const segments = key.split('.');
        let field = segments[segments.length - 1];
        if (segments[0] === 'files') {
          field = 'file';
        }
        if (!mapped[field]) {
          mapped[field] = [];
        }
        mapped[field] = mapped[field].concat(errors[key]);
      });
      this.createRecordErrors = mapped;
    },
    handleRequestError(error, fallbackMessage) {
      if (error.response && error.response.status === 422) {
        this.openSnackbar('لطفاً خطاهای فرم را بررسی کنید.', '#F1416C');
        return;
      }
      if (fallbackMessage) {
        this.openSnackbar(fallbackMessage, '#F1416C');
      } else {
        this.openSnackbar('خطای ناشناخته رخ داد.', '#F1416C');
      }
    }
  }
};
</script>

<style scoped>
.machine-tuning-page {
  direction: rtl;
  text-align: right;
  padding: 24px 0;
}

.page-title {
  font-size: 20px;
  font-weight: bold;
}

.filter-card {
  direction: rtl;
}

.score-input {
  max-width: 120px;
}

.audio-player {
  width: 200px;
}

.file-input {
  width: 100%;
  border: 1px dashed #9e9e9e;
  padding: 12px;
  border-radius: 8px;
}

.file-input-label {
  display: block;
  margin-bottom: 8px;
}

.helper-text {
  font-size: 12px;
  color: #616161;
}

.error-text {
  color: #d32f2f;
  margin-top: 4px;
}

.group-file-field {
  gap: 12px;
}
</style>
